
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.3099 17.38L18.9199 15.25C19.4399 12.89 17.5599 11 15.4999 11C14.3399 11 11.9999 11.9 11.9999 14.5C11.9999 15.31 12.2699 16.05 12.7399 16.65C12.8899 16.85 12.8799 17.13 12.6999 17.31C12.4899 17.52 12.1399 17.5 11.9499 17.27C11.3499 16.5 10.9999 15.54 10.9999 14.5C10.9999 12.8 11.9599 11.33 13.3499 10.57C12.6499 10.21 11.8699 10 11.0699 10C8.68989 10 6.69989 11.65 6.15989 13.87C4.82989 13.48 3.87989 12.21 4.00989 10.73C4.14989 9.16 5.53989 8 7.10989 8H9.10989C10.6899 8 11.8599 7.05 11.9799 5.75C12.1299 4.25 10.9599 3 9.49989 3H8.04989C7.54989 3 7.08989 3.34 7.00989 3.83C6.90989 4.46 7.38989 5 7.99989 5H9.49989C9.77989 5 9.99989 5.22 9.99989 5.5C9.99989 5.78 9.77989 6 9.49989 6H7.15989C4.48989 6 2.16989 8.03 2.00989 10.7C1.85989 13.25 3.61989 15.42 5.99989 15.9V15.93C5.99989 18.73 8.26989 21 11.0699 21H19.9299C21.7999 21 22.7399 18.66 21.3099 17.38ZM17.9999 19C17.4499 19 16.9999 18.55 16.9999 18C16.9999 17.45 17.4499 17 17.9999 17C18.5499 17 18.9999 17.45 18.9999 18C18.9999 18.55 18.5499 19 17.9999 19Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-pest-control-rodent`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPestControlRodent

    ```js
    <b-new-b-icon-pest-control-rodent />
    ```
</docs>


